import { useEffect } from 'react';

// Branded placeholder shown if any <img> on the site fails to load.
const FALLBACK_SRC = '/image-fallback.svg';

// Global image error guard. Image `error` events do not bubble, so we listen
// on the capture phase at the window level to catch failures from any <img>
// anywhere in the app — without having to edit every image tag.
const ImageFallback = () => {
  useEffect(() => {
    const handler = (e) => {
      const el = e.target;
      if (
        el &&
        el.tagName === 'IMG' &&
        el.dataset.fallbackApplied !== 'true' &&
        !el.src.endsWith(FALLBACK_SRC)
      ) {
        el.dataset.fallbackApplied = 'true';
        el.src = FALLBACK_SRC;
      }
    };
    window.addEventListener('error', handler, true);
    return () => window.removeEventListener('error', handler, true);
  }, []);

  return null;
};

export default ImageFallback;
